import { TOptions } from 'i18next';
import { useTranslation } from 'react-i18next';

/**
 * Custom hook for translation
 * This hook wraps the `useTranslation` hook from `react-i18next`
 * and allows for prefixing translation keys.
 *
 * @param prefix - A string prefix to prepend to translation keys.
 *  If provided, all translation keys will be prefixed with this string.
 *  Pass in the path of the translation files, e.g. 'pages.members.login'
 *  or use util getNamespaceFromPath(import.meta.url)
 *
 * @return An object containing the translation function `t` and other properties from `useTranslation`.
 */
const useTranslate = (prefix = '') => {
  const { t: baseT, ...rest } = useTranslation();
  const t = <Result extends string = string>(key: string, options?: TOptions): Result => {
    const fullKey = prefix ? `${prefix}.${key}` : key;
    return baseT(fullKey, options) as Result;
  };
  return { t, ...rest };
};

export default useTranslate;
